import { useMemo, useContext } from 'react';

import { PresetsContext } from '../../PresetsContext';
import PresetActionsComponent from './PresetActions';

const PresetActions = ({
  onClose,
  actions,
  isActive,
  isOwner,
  isChanged,
  screenData,
  titleDialogUpdate,
  labelReset = 'Reset',
  labelUpdate = 'Update',
  ...item
}) => {
  const {
    onUpdatePreset,
    onRenamePreset,
    onDeletePreset,
    onSharePreset,
    onUnsharePreset,
    onResetPreset,
  } = useContext(PresetsContext);

  const handleReset = () => {
    onClose();
    onResetPreset({ preset: item });
  };

  const handleUpdate = async () => {
    await onUpdatePreset(item);
  };
  const handleRename = async () => {
    await onRenamePreset(item);
  };
  const handleDelete = async () => {
    await onDeletePreset(item);
  };
  const handleShare = async () => {
    await onSharePreset(item);
  };

  const handleUnshare = async () => {
    await onUnsharePreset(item);
  };

  const limit = useMemo(() => {
    let result = 0;
    if (isActive && isChanged) {
      result += 3;
    }
    return result;
  }, [isActive, isChanged]);

  return (
    <PresetActionsComponent
      limit={limit}
      isActive={isActive}
      isOwner={isOwner}
      isChanged={isChanged}
      isPublic={item.isPublic}
      onReset={handleReset}
      onUpdate={handleUpdate}
      onShare={handleShare}
      onUnshare={handleUnshare}
      onRename={handleRename}
      onDelete={handleDelete}
      labelReset={labelReset}
      labelUpdate={labelUpdate}
      actions={actions}
    />
  );
};

export default PresetActions;
